<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4">
  <div class="flex flex-column gap-2 w-full">
    <label for="payment-page-name">{{ i18n.i18nLng()['PAYMENTPAGENAME'] }}<sup class="sps-sup">*</sup></label>
    <input pInputText
           id="payment-page-name"
           maxlength="70"
           [(ngModel)]="paymentPageData.name"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"/>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <div class="flex align-items-center">
      <p-checkbox inputId="redirect-via-get"
                  [(ngModel)]="paymentPageData.redirectViaGet"
                  [binary]="true"
                  size="large"/>
      <label for="redirect-via-get" class="ml-2 text-lg">{{ i18n.i18nLng()['REDIRECTVIAGET'] }}</label>
    </div>
    <small style="line-height: 1.5rem" id="redirect-via-get-info">{{ i18n.i18nLng()['REDIRECTVIAGETINFO'] }}</small>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <fieldset class="sps-fieldset form-data-container separator">
      <div class="flex flex-column">
        <legend class="text-lg">{{ i18n.i18nLng()['PAYMENTTYPES'] }}</legend>
      </div>
      <div class="grid w-full">
        <div class="col-12">
          <div style="max-width: 637px;">
            <p-pickList [source]="availablePaymentMethods"
                        [target]="selectedPaymentMethods"
                        [dragdrop]="false"
                        [showSourceControls]="false"
                        [showTargetControls]="false"
                        styleClass="w-full"
                        [rightButtonAriaLabel]="i18n.i18nLng()['ADDPAYMENTTYPE']"
                        [leftButtonAriaLabel]="i18n.i18nLng()['REMOVEPAYMENTTYPE']"
                        [allRightButtonAriaLabel]="i18n.i18nLng()['ADDALLPAYMENTTYPES']"
                        [allLeftButtonAriaLabel]="i18n.i18nLng()['REMOVEALLPAYMENTTYPES']"
                        [attr.aria-label]="i18n.i18nLng()['PAYMENTTYPES']"
                        (onMoveToTarget)="addPaymentMethod($event)"
                        (onMoveAllToTarget)="addPaymentMethods($event)"
                        (onMoveToSource)="removePaymentMethod($event)"
                        (onMoveAllToSource)="removePaymentMethods($event)">
              <ng-template #item let-item>
                <div class="flex align-items-center gap-2 overflow-hidden" [pTooltip]="item.title + ' (' + item.projectId  + ')'">
                  @if (!item.customIcon) {
                    <i class="icon" [ngClass]="item.icon"></i>
                  } @else {
                    <sps-custom-icon [name]="item.icon" [size]="14"></sps-custom-icon>
                  }
                  <div class="picklist-item-label">{{ item.title + ' (' + item.projectId  + ')' }}</div>
                </div>
              </ng-template>
            </p-pickList>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="agb-link">{{ i18n.i18nLng()['T&CLINK'] }}</label>
    <input pInputText
           id="agb-link"
           maxlength="2048"
           [(ngModel)]="paymentPageData.agbLink"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"
           [attr.aria-label]="i18n.i18nLng()['T&CLINKINFO']"/>
    <small style="line-height: 1.5rem" id="agb-link-info">{{ i18n.i18nLng()['T&CLINKINFO'] }}</small>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="imprint-link">{{ i18n.i18nLng()['IMPRINTLINK'] }}</label>
    <input pInputText
           id="imprint-link"
           maxlength="2048"
           [(ngModel)]="paymentPageData.imprintLink"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"
           [attr.aria-label]="i18n.i18nLng()['IMPRINTLINKINFO']"/>
    <small style="line-height: 1.5rem" id="imprint-link-info">{{ i18n.i18nLng()['IMPRINTLINKINFO'] }}</small>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="pp-link">{{ i18n.i18nLng()['PRIVACYPOLOCYLINK'] }}</label>
    <input pInputText
           id="pp-link"
           maxlength="2048"
           [(ngModel)]="paymentPageData.privacyPolicyLink"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"
           [attr.aria-label]="i18n.i18nLng()['PRIVACYPOLOCYLINKINFO']"/>
    <small style="line-height: 1.5rem" id="pp-link-info">{{ i18n.i18nLng()['PRIVACYPOLOCYLINKINFO'] }}</small>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="aria-link">{{ i18n.i18nLng()['ACCESSIBILITYLINK'] }}</label>
    <input pInputText
           id="aria-link"
           maxlength="2048"
           [(ngModel)]="paymentPageData.accessibilityLink"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"
           [attr.aria-label]="i18n.i18nLng()['ACCESSIBILITYLINKINFO']"/>
    <small style="line-height: 1.5rem" id="aria-link-info">{{ i18n.i18nLng()['ACCESSIBILITYLINKINFO'] }}</small>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="aria-mail">{{ i18n.i18nLng()['ACCESSIBILITYMAIL'] }}</label>
    <input pInputText
           id="aria-mail"
           maxlength="254"
           [(ngModel)]="paymentPageData.accessibilityEMail"
           [required]="false"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"
           [attr.aria-label]="i18n.i18nLng()['ACCESSIBILITYMAILINFO']"
           (blur)="validateEmail()"/>
    @if (!isValidMail) {
      <small style="line-height: 1.5rem" class="text-error" role="alert" id="aria-mail-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILINFO'] }}</small>
    } @else {
      <small style="line-height: 1.5rem" id="aria-mail-info">{{ i18n.i18nLng()['ACCESSIBILITYMAILINFO'] }}</small>
    }
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="aria-phone">{{ i18n.i18nLng()['ACCESSIBILITYPHONE'] }}</label>
    <input pInputText
           id="aria-phone"
           maxlength="30"
           [(ngModel)]="paymentPageData.accessibilityPhone"
           [required]="true"
           [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
           pSize="large"
           [attr.aria-label]="i18n.i18nLng()['ACCESSIBILITYPHONEINFO']"/>
    <small style="line-height: 1.5rem" id="aria-phone-info">{{ i18n.i18nLng()['ACCESSIBILITYPHONEINFO'] }}</small>
  </div>
</div>
